import type { AnyObject, TestConfig } from 'yup';

import { t } from '@luna/i18n';

import type { PhoneNumber } from './LiphoneApiTypes';

const ALLOWED_PHONE_NUMBER_TYPES = ['FIXED_LINE_OR_MOBILE', 'MOBILE', 'FIXED_LINE', 'VOIP'];

function isAllowedPhoneNumber(phoneNumber: PhoneNumber): boolean {
    return ALLOWED_PHONE_NUMBER_TYPES.includes(phoneNumber.getType() as string);
}

export const YUP_PHONE_NUMBER_TEST_CONFIG: TestConfig<string | undefined, AnyObject> = {
    name: 'libphonenumber',
    async test(value, testContext) {
        if (!value) {
            return true;
        }

        const { parsePhoneNumberFromString } = await import('libphonenumber-js/max');
        const phoneNumber = parsePhoneNumberFromString(value);
        if (!phoneNumber || !phoneNumber.isValid()) {
            return testContext.createError({
                message: t('contactDataManagement.phoneContactForm.numberIncorrect'),
            });
        }

        if (!isAllowedPhoneNumber(phoneNumber)) {
            return testContext.createError({
                message: t('contactDataManagement.phoneContactForm.numberNotAccepted'),
            });
        }

        return true;
    },
};
